import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import { selectModalState, setCommonModalState } from '../../../../store/slices/commonModalSlice'
import { CommonModals } from '../../../types/enums'

export const useSort = () => {
  const dispatch = useDispatch()
  const expanded = useSelector((state: RootState) => selectModalState(state, CommonModals.SORT))

  const setSortState = (state: boolean) =>
    dispatch(setCommonModalState({ modal: CommonModals.SORT, state }))

  const toggleExpanded = () => {
    if (expanded) {
      setSortState(false)
      return
    }
    setSortState(true)
  }

  return { expanded, toggleExpanded }
}
